/**
 * @def Defines available StoreLocatorRegions for the application.
 */
export enum StoreLocatorRegion {
  US = 'us',
  EU = 'eu',
}
